import { DetailedHTMLProps, TextareaHTMLAttributes } from 'react';
import { observer } from 'mobx-react-lite';

export const AutogrowTextarea = observer(
  (
    props: DetailedHTMLProps<
      TextareaHTMLAttributes<HTMLTextAreaElement>,
      HTMLTextAreaElement
    > & { error?: boolean },
  ) => {
    const updateHeight = (el: HTMLTextAreaElement) => {
      const update = () => {
        const bounding = el.getBoundingClientRect();
        if (bounding.width > 0) {
          clearInterval(interval);

          const copy = el.cloneNode(true) as HTMLTextAreaElement;
          copy.style.opacity = '0';
          copy.style.position = 'fixed';
          copy.style.left = '-9999px';
          copy.style.width = `${bounding.width}px`;
          copy.style.height = '1px';

          document.body.append(copy);

          el.style.height = `${copy.scrollHeight}px`;
          copy.remove();
        }
      };

      const interval = setInterval(update, 100);
      update();
    };

    return (
      <textarea
        {...props}
        className={`${props.className ?? ''} autogrow_textarea ${props.error ? 'invalid_field' : ''}`}
        onKeyDown={(ev) => {
          props?.onKeyDown?.(ev);
          if (!ev.isDefaultPrevented() && ev.code === 'Enter' && ev.ctrlKey) {
            (ev.target as HTMLElement)
              .closest<HTMLFormElement>('form')
              ?.querySelector<HTMLButtonElement>('button[type="submit"]')
              ?.click();
          }
        }}
        ref={(el) => {
          if (el instanceof HTMLTextAreaElement) {
            updateHeight(el);
          }
        }}
        onChange={(ev) => {
          props?.onChange?.(ev);
          updateHeight(ev.target as HTMLTextAreaElement);
        }}
      />
    );
  },
);
